import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  paper: {
    minWidth: "580px",
    minHeight: "600px",
    overflow: "auto",
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
    },
  },
  avatarRoot: {
    border: "none",
  },
  avatar: {
    width: "67px",
    height: "67px",
    fontSize: "36px",
  },
  name: {
    color: "#190D27",
  },
  greenText: {
    color: "#23B12E",
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  colorPink: {
    color: theme.palette.primary.dark,
  },
  title: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(2),
  },
  buttonText: {
    fontSize: "1rem",
    color: theme.palette.primary.dark,
  },
  appliedChip: {
    backgroundColor: "#FFCCA7",
    "&:hover": {
      backgroundColor: "#FFCCA7",
    },
    color: "#F88938",
  },
  viewedChip: {
    backgroundColor: "#33A3B139",
    "&:hover": {
      backgroundColor: "#33A3B139",
    },
    color: "#33A3B1",
  },
  appointedChip: {
    backgroundColor: "#B5E5B9",
    "&:hover": {
      backgroundColor: "#B5E5B9",
    },
    color: "#23B12E",
  },
  deferredChip: {
    backgroundColor: "#D6D2DC",
    color: "#412A5D",
  },
  noLongerConsiderationChip: {
    backgroundColor: "#F84738",
    "&:hover": {
      backgroundColor: "#F84738",
    },
    color: "#FFC7C3",
  },
  otherChip: {
    backgroundColor: "#F1E1E9",
    "&:hover": {
      backgroundColor: "#F1E1E9",
    },
    color: "#A01F62",
  },
}))

export default styles
